import { render, staticRenderFns } from "./GridAprobacion.vue?vue&type=template&id=50dac338&"
import script from "./GridAprobacion.vue?vue&type=script&lang=js&"
export * from "./GridAprobacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports